import { render, staticRenderFns } from "./reg-floting.vue?vue&type=template&id=6df92a77&scoped=true&"
import script from "./reg-floting.vue?vue&type=script&lang=js&"
export * from "./reg-floting.vue?vue&type=script&lang=js&"
import style0 from "./reg-floting.vue?vue&type=style&index=0&id=6df92a77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df92a77",
  null
  
)

export default component.exports